import { render, staticRenderFns } from "./CreateNewPassword.vue?vue&type=template&id=3afbdd9f&scoped=true&lang=pug&"
import script from "./CreateNewPassword.vue?vue&type=script&lang=ts&"
export * from "./CreateNewPassword.vue?vue&type=script&lang=ts&"
import style0 from "./CreateNewPassword.vue?vue&type=style&index=0&id=3afbdd9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afbdd9f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
